import { Tooltip } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { IMAGE_HTML_TYPE, checkBucketUrl, getAxios } from '../../utils';
import './styles.scss';

const TooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: black;
  font-size: 10px;
`;

const Element = ({ item = null, displayName = true, withToolTip = true }) => {
  const zoom = useSelector((appState) => appState.board.zoomRatio);

  const [toolTipSrc, setToolTipSrc] = useState();
  const [component, setComponent] = useState(item);

  const imgRef = useRef(null);

  const onDrag = async (e) => {
    const listElement = document
      .getElementById(`mo__element-drag-${component.id}-${component.name}`)
      .getElementsByTagName('img');

    const cln = listElement[0].cloneNode(true);
    cln.style.backgroundColor = 'transparent';
    cln.style.top = 0;
    cln.style.left = 0;
    cln.style.width = component.content?.width
      ? `${component.content.width * component.content.scaleX * (zoom / 100)}px`
      : '100px';
    cln.style.height = component.content?.height
      ? `${component.content.height * component.content.scaleY * (zoom / 100)}px`
      : '100px';
    cln.style.zIndex = 1;
    cln.id = `mo__element-drag-clone-${component.id}-${component.name}`;

    document.body.appendChild(cln);

    e.dataTransfer.setDragImage(cln, 0, 0);
    e.dataTransfer.setData('on-element-drag', JSON.stringify(component));
  };

  const onDragEnd = () => {
    if (!component.content) return;
    const id = `mo__element-drag-clone-${component.id}-${component.name}`;
    document.getElementById(id)?.remove();
  };

  const getName = (name) => (name.includes('.svg') ? name.substr(0, name.length - 4).replaceAll('-', ' ') : name);

  const updateImageSrc = async () => {
    if (!component.content) {
      const content = await getAxios(checkBucketUrl(component.url));
      const newComponent = { ...component, content };
      setComponent(newComponent);
      setToolTipSrc(newComponent.thumbnailImage);
      return;
    }

    if (component.content.id.includes(IMAGE_HTML_TYPE.stepNav)) {
      // Steps element in common break on safari
      imgRef.current.style.scale = '0.25';
      imgRef.current.style.maxWidth = 'none';
      imgRef.current.style.width = 'unset';
      imgRef.current.style.height = 'unset';
      return;
    }
  };

  useEffect(() => {
    updateImageSrc();
  }, []);

  return (
    <div
      className="mo__element-component"
      id={`mo__element-drag-${component.id}-${component.name}`}
      onDragStart={onDrag}
      onDragEnd={onDragEnd}
      draggable
    >
      {displayName ? (
        <>
          <div className="image">
            <img ref={imgRef} src={component.thumbnailImage} loading="lazy" />
          </div>
          <p>{(component && getName(component.name)) || ''}</p>
        </>
      ) : withToolTip ? (
        <Tooltip
          title={() => (
            <TooltipContent draggable>
              <div>
                <img
                  className="tool-tip-image"
                  src={toolTipSrc}
                  style={{ height: '70px', width: '70px', pointerEvents: 'none' }}
                />
              </div>
              {getName(component.name)}
            </TooltipContent>
          )}
          color="white"
        >
          <div className="image-icon">
            <img className="small-image" ref={imgRef} src={component.thumbnailImage} loading="lazy" />
          </div>
        </Tooltip>
      ) : (
        <div className="image-icon">
          <img className="small-image" ref={imgRef} src={component.thumbnailImage} loading="lazy" />
        </div>
      )}
    </div>
  );
};

export default Element;
